import { Component, ElementRef, ViewChild } from "@angular/core";
import { finalize } from "rxjs/operators";
import swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  AbstractControl,
  
  ValidatorFn,
  
} from "@angular/forms";
import { TipoMantenimientoService } from "../../../../shared/services/tipo_mantenimiento.service";

import {
  
  OrdenMantenimientoService,
  ResumenEstadoOrden,
} from "../../../../shared/services/orden-mantenimiento.service";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectComponent } from "@ng-select/ng-select";
import { PrioridadMantenimientoService } from "../../../../shared/services/prioridad-mantenimiento.service";
import { PrioridadMantenimiento } from "../../../../shared/model/prioridad-mantenimiento.model";
import { EstadoOrdenMantenimientoService } from "../../../../shared/services/estado-orden-mantenimiento.service";
import { HistorialOrden, HistorialOrdenService } from "../../../../shared/services/historial-orden.service";
import { error } from "console";
import { ActividadOrden } from "../../../../shared/model/historial-orden.model";
import { AuthService } from "../../../../shared/services/auth.service";
import { ProgramacionesMantenimientoService } from "../../../../shared/services/programaciones-mantenimiento.service";
import { autoTable } from "jspdf-autotable";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { Administracion } from "../../../../shared/model/administracion.model";


export function noEspaciosEnBlanco(): ValidatorFn {
  return (control: AbstractControl) => {
    const valor = control.value;
    if (typeof valor === "string" && valor.trim() === "") {
      return { espaciosBlancos: true };
    }
    return null;
  };
}
@Component({
  selector: "app-ordenes",
  templateUrl: "./ordenes.component.html",
  styleUrls: ["./ordenes.component.scss"],
})
export class OrdenesComponent {

textoBusqueda = '';
filtroEstado = '';
filtroTipo: number | '' = '';
filtroPrioridad: number | '' = '';

fechaDesde = '';
fechaHasta = '';

cargando = false;

ordenes: any[] = [];
ordenesFiltradas: any[] = [];
ordenesPaginadas: any[] = [];

ordenSeleccionada: any = null;
mostrarModalDetalleOrden = false;

paginaActual = 1;
itemsPorPagina = 10;
administraciones: Administracion[] = [];
estadosOrden: any[] = [];
tiposMantenimiento: any[] = [];
prioridades: any[] = [];
totalEnProceso: number = 0;
totalCanceladas: number = 0;
totalCompletadas: number = 0;
totalPendientes: number = 0;
totalTodas: number = 0;
totalFinalizadas: number = 0;
resumenEstados: ResumenEstadoOrden[] = []; 
TipoMantenimiento: any;
totalEntregadas: number = 0;
totalRecibidas: number = 0;
totalPausadas: number = 0;
totalRealizadas: number = 0;
fechaActual: string = this.obtenerFechaActual();
historial: HistorialOrden[] = [];
cargandoHistorial = false;
actividadesOrden: ActividadOrden[] = [];
ordenEntregada = false;
mostrarModalActividad = false;

modoConsulta = false;
guardandoActividad = false;
actividadSeleccionada: any = null;
formResultadoActividad!: FormGroup;
evidenciasSeleccionadas: File[] = [];
modoConsultaActividad = false;
progresoActividades = 0;
finalizandoOrden = false;



  @ViewChild("inputSolicitado") inputSolicitado!: NgSelectComponent;
  @ViewChild("inputPlaca") inputPlaca!: NgSelectComponent;
  @ViewChild("inputTipotrabajo") inputTipotrabajo!: NgSelectComponent;
  @ViewChild("inputTipomantenimiento")
  inputTipomantenimiento!: NgSelectComponent;
  @ViewChild("inputKm") inputKm!: ElementRef<HTMLInputElement>;
  @ViewChild("inputKmProximo") inputKmProximo!: ElementRef<HTMLInputElement>;
  usuarioLogin: any;
  
 
  

  constructor(
    private fb: FormBuilder,
    private OrdenMantenimientoService: OrdenMantenimientoService,
    private prioridadMantenimientoService: PrioridadMantenimientoService,    
    private tipoMantenimientosService: TipoMantenimientoService,
    private estadoOrdenMantenimientoService: EstadoOrdenMantenimientoService,
    private HistorialOrdenService: HistorialOrdenService,
    private authService: AuthService,
    private programacionesMantenimientoService: ProgramacionesMantenimientoService,
    private administracionesServices: AdministracionService
  ) {}

  ngOnInit() {
    try {
      this.cargarOrdenes();
      this.cargarPrioridades();
      this.cargarTiposMantenimiento();
      this.cargarEstadosOrden();
      this.cargarAdministracion();
      this.usuarioLogin = this.authService.getCurrentUserValue();
    } catch (error) {
      console.error('Error al cargar las órdenes de mantenimiento', error);
    }
    
  }

crearFormularioActividad(): void {
  this.formResultadoActividad = this.fb.group({
    resultado: ['REALIZADA', Validators.required],
    kilometraje_ejecucion: [
      null,
      [Validators.required, Validators.min(0)]
    ],
    fecha_ejecucion: [this.fechaLocalActual(), Validators.required],
    diagnostico: ['', Validators.required],
    trabajo_realizado: ['', Validators.required],
    trabajo_pendiente: [''],
    motivo_no_realizacion: [''],
    observaciones: [''],
    requiere_seguimiento: [false, Validators.required],
    descripcion_seguimiento: ['']
  });

  this.formResultadoActividad.get('resultado')!
    .valueChanges.subscribe(resultado => {
      this.actualizarValidacionesResultado(resultado);
    });

  this.formResultadoActividad.get('requiere_seguimiento')!
    .valueChanges.subscribe(requiere => {
      const control = this.formResultadoActividad.get(
        'descripcion_seguimiento'
      )!;

      if (requiere) {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
        control.setValue('');
      }

      control.updateValueAndValidity({ emitEvent: false });
    });
}

private actualizarValidacionesResultado(resultado: string): void {
  const kilometraje = this.formResultadoActividad.get(
    'kilometraje_ejecucion'
  )!;
  const diagnostico = this.formResultadoActividad.get('diagnostico')!;
  const trabajo = this.formResultadoActividad.get('trabajo_realizado')!;
  const pendiente = this.formResultadoActividad.get('trabajo_pendiente')!;
  const motivo = this.formResultadoActividad.get('motivo_no_realizacion')!;

  if (resultado === 'NO_REALIZADA') {
    kilometraje.clearValidators();
    diagnostico.clearValidators();
    trabajo.clearValidators();
    pendiente.clearValidators();
    motivo.setValidators([Validators.required]);
  } else {
    kilometraje.setValidators([
      Validators.required,
      Validators.min(0)
    ]);
    diagnostico.setValidators([Validators.required]);
    trabajo.setValidators([Validators.required]);
    motivo.clearValidators();

    if (resultado === 'PARCIAL') {
      pendiente.setValidators([Validators.required]);
    } else {
      pendiente.clearValidators();
    }
  }

  [
    kilometraje,
    diagnostico,
    trabajo,
    pendiente,
    motivo
  ].forEach(control => {
    control.updateValueAndValidity({ emitEvent: false });
  });
}


  get totalPaginas(): number {
  return Math.max(
    1,
    Math.ceil(this.ordenesFiltradas.length / this.itemsPorPagina)
  );
}

get rangoMostrado(): string {
  if (!this.ordenesFiltradas.length) {
    return '0 registros';
  }

  const inicio = (this.paginaActual - 1) * this.itemsPorPagina + 1;
  const fin = Math.min(
    this.paginaActual * this.itemsPorPagina,
    this.ordenesFiltradas.length
  );

  return `${inicio} - ${fin} de ${this.ordenesFiltradas.length}`;
}

get paginasVisibles(): (number | string)[] {
  return Array.from(
    { length: this.totalPaginas },
    (_, i) => i + 1
  );
}

resetearPaginacion(): void {
  this.paginaActual = 1;
  this.aplicarFiltros();
}





aplicarFiltros(): void {
   if (!this.validarRangoFechas()) {
    swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'La fecha final no puede ser mayor que la fecha inicial.'
    });
    return;
  }
  const texto = String(this.textoBusqueda ?? '')
    .trim()
    .toLowerCase();

  const normalizar = (valor: unknown): string =>
    String(valor ?? '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '_');

  const filtroEstado = normalizar(this.filtroEstado);

  const filtroTipo = this.filtroTipo;
  const filtroPrioridad = this.filtroPrioridad;

  this.ordenesFiltradas = (this.ordenes ?? []).filter(
    (orden: any) => {

      // 1. Búsqueda por número de orden o placa
      const numero = String(orden.numero_orden ?? '')
        .trim()
        .toLowerCase();

      const placa = String(orden.placa ?? '')
        .trim()
        .toLowerCase();

      const coincideTexto =
        !texto ||
        numero.includes(texto) ||
        placa.includes(texto);

      // 2. Estado de la orden
      const estado = normalizar(
        orden.estado?.codigo ??
        orden.estado?.nombre ??
        this.obtenerEstado(orden)
      );

      const coincideEstado =
        !filtroEstado || estado === filtroEstado;

      // 3. Tipo de mantenimiento
      const tipoId = Number(orden.tipo_mantenimiento_id);

      const coincideTipo =
        this.filtroTipo == null ||
        this.filtroTipo === '' ||
        tipoId === Number(filtroTipo);

      // 4. Prioridad
      const prioridadId = Number(orden.prioridad_id);

      const coincidePrioridad =
        this.filtroPrioridad == null ||
        this.filtroPrioridad === '' ||
        prioridadId === Number(filtroPrioridad);

      // 5. Fecha de generación
      const fecha = String(orden.fecha_generacion ?? '')
        .slice(0, 10);

      const coincideFechaDesde =
        !this.fechaDesde ||
        (!!fecha && fecha >= this.fechaDesde);

      const coincideFechaHasta =
        !this.fechaHasta ||
        (!!fecha && fecha <= this.fechaHasta);

      return (
        coincideTexto &&
        coincideEstado &&
        coincideTipo &&
        coincidePrioridad &&
        coincideFechaDesde &&
        coincideFechaHasta
      );
    }
  );

  // 6. Actualizar paginación
  this.actualizarPagina();
}

validarRangoFechas(): boolean {
  console.log('Fecha inicial:', this.fechaDesde);
  console.log('Fecha final:', this.fechaHasta);

  // Validar fechas futuras
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  if (this.fechaDesde) {
    const fechaDesde = new Date(`${this.fechaDesde}T00:00:00`);

    if (isNaN(fechaDesde.getTime())) {
      swal.fire({
        icon: 'error',
        title: 'Fecha inválida',
        text: 'Verifica la fecha inicial.'
      });
      return false;
    }

    if (fechaDesde > hoy) {
      swal.fire({
        icon: 'error',
        title: 'Fecha futura',
        text: 'La fecha inicial no puede ser posterior a hoy.'
      });
      return false;
    }
  }

  if (this.fechaHasta) {
    const fechaHasta = new Date(`${this.fechaHasta}T00:00:00`);

    if (isNaN(fechaHasta.getTime())) {
      swal.fire({
        icon: 'error',
        title: 'Fecha inválida',
        text: 'Verifica la fecha final.'
      });
      return false;
    }

    if (fechaHasta > hoy) {
      swal.fire({
        icon: 'error',
        title: 'Fecha futura',
        text: 'La fecha final no puede ser posterior a hoy.'
      });
      return false;
    }
  }

  // Validar que la fecha final no sea anterior a la inicial
  if (this.fechaDesde && this.fechaHasta) {
    if (this.fechaHasta < this.fechaDesde) {
      swal.fire({
        icon: 'error',
        title: 'Rango de fechas inválido',
        text: 'La fecha final no puede ser anterior a la fecha inicial.'
      });
      return false;
    }
  }

  return true;
}


actualizarPagina(): void {
  this.paginaActual = Math.min(this.paginaActual, this.totalPaginas);

  const inicio = (this.paginaActual - 1) * this.itemsPorPagina;

  this.ordenesPaginadas = this.ordenesFiltradas.slice(
    inicio,
    inicio + this.itemsPorPagina
  );
}

limpiarFiltros(): void {
  this.textoBusqueda = '';
  this.filtroEstado = '';
  this.filtroTipo = '';
  this.filtroPrioridad = '';
  this.fechaDesde = '';
  this.fechaHasta = '';

  this.aplicarFiltros();
}

cambiarItemsPorPagina(): void {
  this.paginaActual = 1;
  this.actualizarPagina();
}

paginaAnterior(): void {
  if (this.paginaActual > 1) {
    this.paginaActual--;
    this.actualizarPagina();
  }
}

paginaSiguiente(): void {
  if (this.paginaActual < this.totalPaginas) {
    this.paginaActual++;
    this.actualizarPagina();
  }
}

irAPagina(pagina: number | string): void {
  if (typeof pagina !== 'number') {
    return;
  }

  if (pagina >= 1 && pagina <= this.totalPaginas) {
    this.paginaActual = pagina;
    this.actualizarPagina();
  }
}




verDetalleOrden(orden: any): void {
  this.ordenSeleccionada = {
    ...orden,
    historial: [],
    actividadesOrden: []
  };
  const estadoOrden = this.getEstadoOrden(orden);
 
//preguntar si la orden está entregada
  this.ordenEntregada = estadoOrden === 'ENTREGADA';

  this.historial = [];
  this.actividadesOrden = [];
  this.mostrarModalDetalleOrden = true;

  // 1. Consultar actividades de la orden

  this.cargarActividadesOrden(orden.id);
 

  // 2. Consultar historial de la orden
  this.HistorialOrdenService
    .obtenerPorOrden(orden.id)
    .subscribe({
      next: (response: any) => {
        if (response?.codigo !== 0) {
          console.error(
            'No se pudo consultar el historial:',
            response?.mensaje
          );
          return;
        }

        const historial = Array.isArray(
          response?.data?.historial
        )
          ? response.data.historial
          : [];

        this.historial = historial;

        this.ordenSeleccionada = {
          ...this.ordenSeleccionada,
          historial
        };

      //  console.log('Historial:', historial);
      },
      error: (error: any) => {
        console.error(
          'Error al obtener el historial de la orden:',
          error
        );

        this.historial = [];

        this.ordenSeleccionada = {
          ...this.ordenSeleccionada,
          historial: []
        };
      }
    });
}



cerrarDetalleOrden(): void {
  this.mostrarModalDetalleOrden = false;
  this.ordenSeleccionada = null;
}

contarPorEstado(estadoBuscado: string): number {
  return this.ordenes.filter(
    (orden: any) => this.normalizarEstado(orden) === estadoBuscado
  ).length;
}

normalizarEstado(orden: any): string {
  return String(
    orden.estado?.nombre ??
    orden.estado_nombre ??
    orden.estado ??
    ''
  ).trim().toUpperCase().replace(/\s+/g, '_');
}
  
normalizarEstadoOrden(orden: any): string {
  return String(
    orden.estado?.codigo ??
    
    ''
  ).trim().toUpperCase().replace(/\s+/g, '_');
}



obtenerClaseEstado(orden: any): string {
  const estado = this.normalizarEstadoOrden(orden);

  const clases: Record<string, string> = {
    PENDIENTE: 'status-pending',
    ENTREGADA: 'status-send',
    RECIBIDA: 'status-received',
    EN_PROCESO: 'status-progress',
    PAUSADA: 'status-warning',
    FINALIZADA: 'status-completed',
    CANCELADA: 'status-cancelled'
  };

  return clases[estado] ?? 'status-pending';
}

obtenerClasePrioridad(orden: any): string {
  const prioridad = this.obtenerPrioridad(orden);
 
  const clases: Record<string, string> = {
    BAJA: 'status-completed',
    NORMAL: 'status-pending',
    ALTA: 'status-warning',
    URGENTE: 'status-cancelled'
  };

  return clases[prioridad] ?? 'status-pending';
}

puedeIniciar(orden: any): boolean {
  return this.normalizarEstado(orden) === 'RECIBIDA';
}

 
//LLAMAR EL SERVICIO PARA OBTENER LAS ÓRDENES DE MANTENIMIENTO

cargarOrdenes(): void {
  this.cargando = true;

  this.OrdenMantenimientoService.getAll()
    .pipe(
      finalize(() => {
        this.cargando = false;
      })
    )
    .subscribe({
      next: (response: any) => {
        // Cargar órdenes
        this.ordenes = Array.isArray(response?.data)
          ? response.data
          : [];

        // Cargar resumen de cantidades por estado
        this.resumenEstados = Array.isArray(response?.resumenEstados)
          ? response.resumenEstados
          : [];

        // Actualizar tarjetas de resumen
   

        // Reiniciar paginación y aplicar filtros
        this.paginaActual = 1;
        this.aplicarFiltros();
      },

      error: (error: any) => {
        console.error(
          'Error al cargar las órdenes de mantenimiento:',
          error
        );

        // Limpiar información si falla la petición
        this.ordenes = [];
        this.ordenesFiltradas = [];
        this.ordenesPaginadas = [];
        this.resumenEstados = [];

        this.totalPendientes = 0;
        this.totalEntregadas = 0;
        this.totalRecibidas = 0;
        this.totalEnProceso = 0;
        this.totalPausadas = 0;
        this.totalRealizadas = 0;
        this.totalCanceladas = 0;
      }
    });
}

obtenerCantidadEstado(estadoId: number): number {
  const estado = this.resumenEstados.find(
    (item: any) => Number(item.estado_id) === estadoId
  );

  return Number(estado?.cantidad ?? 0);
}

obtenerTipoMantenimiento(orden: any): string {
  return orden.tipoMantenimiento?.nombre
    ?? orden.tipoMantenimiento?.codigo
    ?? 'SIN TIPO';
}

obtenerEstado(orden: any): string {
  return String(
    orden.estado?.codigo ??
    orden.estado?.nombre ??
    'SIN_ESTADO'
  )
    .trim()
    .toUpperCase()
    .replace(/_/g, ' ');
}

obtenerPrioridad(orden: any): string {
  return orden.prioridadMantenimiento?.nombre.toUpperCase()
    ?? orden.prioridad?.nombre.toUpperCase()
    ?? 'SIN PRIORIDAD';
}


obtenerEtiquetaEstado(codigo: string): string {
  const etiquetas: Record<string, string> = {
    PENDIENTE: 'Pendientes',
    ENTREGADA: 'Entregadas',
    RECIBIDA: 'Recibidas',
    EN_PROCESO: 'En proceso',
    PAUSADA: 'Pausadas',
    REALIZADA: 'Realizadas',
    CANCELADA: 'Canceladas'
  };

  return etiquetas[codigo?.toUpperCase()] ?? codigo;
}

obtenerClaseEstadoCard(codigo: string): string {
  const clases: Record<string, string> = {
    PENDIENTE: 'pending',
    ENTREGADA: 'delivered',
    RECIBIDA: 'received',
    EN_PROCESO: 'in-progress',
    PAUSADA: 'paused',
    FINALIZADA: 'completed',
    CANCELADA: 'cancelled'
  };

  return clases[codigo?.toUpperCase()] ?? 'pending';
}

obtenerIconoEstado(codigo: string): string {
  const iconos: Record<string, string> = {
    PENDIENTE: 'icofont icofont-clock-time',
    ENTREGADA: 'icofont icofont-truck-alt',
    RECIBIDA: 'icofont icofont-check-circled',
    EN_PROCESO: 'icofont icofont-tools',
    PAUSADA: 'icofont icofont-pause',
    FINALIZADA: 'icofont icofont-verification-check',
    CANCELADA: 'icofont icofont-close-circled'
  };

  return iconos[codigo?.toUpperCase()]
    ?? 'icofont icofont-list';
}

  cargarPrioridades(): void {
    this.prioridadMantenimientoService.getAll().subscribe(
      (prioridades: PrioridadMantenimiento[]) => {
        this.prioridades = prioridades;
      },
      (error) => {
        console.error('Error al obtener las prioridades:', error);
      }
    );
  }

 cargarTiposMantenimiento(): void {
    this.tipoMantenimientosService.getTipos().subscribe({
      next: (data) => (this.TipoMantenimiento = data),
      error: (error) =>
        console.error("❌ Error al obtener el mantenimiento:", error),
    });
  }   

  cargarEstadosOrden(): void {
  this.estadoOrdenMantenimientoService.getAll().subscribe({
    next: (respuesta: any) => {
      //console.log('Respuesta estados:', respuesta);

      this.estadosOrden = Array.isArray(respuesta?.data)
        ? respuesta.data
        : [];

     // console.log('Estados cargados:', this.estadosOrden);
    },
    error: (error) => {
      console.error('Error cargando estados:', error);
      this.estadosOrden = [];
    }
  });
}


  alCambiarPrioridad(prioridadId: number | null): void {
  this.filtroPrioridad = prioridadId!;
  this.paginaActual = 1;
  this.aplicarFiltros();
}

alCambiarTipo(tipoId: number | null): void {
  this.filtroTipo = tipoId!;
  this.paginaActual = 1;
  this.aplicarFiltros();
}

alCambiarEstado(estadoNombre: string | null): void {
  this.filtroEstado = estadoNombre!;
  this.paginaActual = 1;
  this.aplicarFiltros();
}
alCambiarFechaDesde(fecha: string): void {
  this.fechaDesde = fecha;
  this.resetearPaginacion();
  this.validarRangoFechas();
}

alCambiarFechaHasta(fecha: string): void {
  this.fechaHasta = fecha;
  this.resetearPaginacion();
  this.validarRangoFechas();
}

obtenerFechaActual(): string {
  const hoy = new Date();

  const anio = hoy.getFullYear();
  const mes = String(hoy.getMonth() + 1).padStart(2, '0');
  const dia = String(hoy.getDate()).padStart(2, '0');

  return `${anio}-${mes}-${dia}`;
}


contarActividades(codigo: string): number {
  return (this.actividadesOrden || []).filter(
    (actividad: any) =>
      this.obtenerCodigoEstadoActividad(actividad) === codigo
  ).length;
}

enviarOrden(orden: any): void {
  console.log('Enviar orden:', orden);
  //preguntar al usuario si está seguro de enviar la orden antes de proceder.
  swal.fire({
    title: '¿Estás seguro?',
    text: '¿Deseas enviar esta orden?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, enviar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      // Lógica para enviar la orden.
      
    }
  });
}

obtenerCodigoEstadoActividad(actividad: any): string {
  //console.log('Obteniendo código de estado para la actividad:', actividad);
  return String(
    actividad?.estadoActividadMantenimiento?.codigo ??
   
    ''
  ).trim().toUpperCase();
}

obtenerNombreEstadoActividad(actividad: any): string {
  const estado = actividad?.estadoActividadMantenimiento;

  if (estado?.nombre) {
    return estado.nombre;
  }

  const nombres: Record<string, string> = {
    PENDIENTE: 'Pendiente',
    EN_PROCESO: 'En proceso',
    PAUSADA: 'Pausada',
    FINALIZADA: 'Finalizada',
    CANCELADA: 'Cancelada'
  };

  return nombres[this.obtenerCodigoEstadoActividad(actividad)]
    || 'Sin estado';
}

obtenerClaseEstadoActividad(actividad: any): string {
  const clases: Record<string, string> = {
    PENDIENTE: 'estado-pendiente',
    EN_PROCESO: 'estado-proceso',
    PAUSADA: 'estado-pausada',
    REALIZADA: 'estado-finalizada',
    CANCELADA: 'estado-cancelada'
  };

  return clases[this.obtenerCodigoEstadoActividad(actividad)]
    || 'estado-desconocido';
    
}

calcularProgresoActividades(): number {
  //console.log('Calculando progreso de actividades...');
  const total = this.actividadesOrden?.length || 0;

  if (total === 0) {
    return 0;
  }

  return Math.round(
    (this.contarActividades('REALIZADA') / total) * 100
  );
}

verDetalleActividad(actividad: any): void {
  console.log('Actividad seleccionada:', actividad);

  // Aquí puedes abrir el modal de detalle.
}

iniciarActividad(actividad: any): void {
  // Conectar con el endpoint para cambiar
  // el estado a EN_PROCESO.
  console.log('Iniciar actividad:', actividad);
}

finalizarActividad(actividad: any): void {
  // Abrir el formulario para registrar
  // el trabajo realizado antes de finalizar.
  console.log('Finalizar actividad:', actividad);
}


gestionarOrden(actividad: any): void {
  console.log('1. Actividad recibida:', actividad);

  this.actividadSeleccionada = actividad;
  this.mostrarModalActividad = true;

  console.log('2. Estado del modal:', this.mostrarModalActividad);
  console.log('3. Actividad asignada:', this.actividadSeleccionada);
}

cerrarModalActividad(): void {
  this.mostrarModalActividad = false;
  this.actividadSeleccionada = null;
}

GestionarEstadoOrden(orden: any, estado: number): void {
  if (!orden) {
    swal.fire('Error', 'Orden no válida', 'error');
    return;
  }

  console.log('Gestionar estado de la orden:', orden, 'Estado solicitado:', estado);
  let titulo = '';
  switch (estado) {
     case 1:
      // Reanudar orden
      titulo = 'Reanudar orden';
      // Aquí puedes conectar con el endpoint para reanudar la orden.
      break;
    case 7:
      // cancelar orden
     titulo = 'Cancelar orden';
      break;
    case 5:
      // Pausar orden
      titulo = 'Pausar orden';
      // Aquí puedes conectar con el endpoint para pausar la orden.
      break;


   
    default:
      console.warn('Estado no manejado:', estado);
      break;
  }

   // Preguntar si desea enviar la orden
   swal.fire({
        title: titulo,
        text: `¿Desea ${titulo.toLowerCase()}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: `Sí, ${titulo.toLowerCase()}`,
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // Aquí puedes conectar con el endpoint para enviar la orden.
        //  console.log('Orden enviada:', orden);
          //this.entregarOrden(orden);
          //servicio para enviar la orden
            if (estado === 7) {
              this.cancelarOrden(orden);
            } else if (estado === 5) {
              this.pausarOrden(orden);
            }else if (estado === 1) {
              this.reanudarOrden(orden);
            }
          
        }
      });
  
  
}

GenerarOrden(orden: any): void {
//  console.log('Generar orden:', orden);
  // Aquí puedes conectar con el endpoint para enviar la orden.
  if (!orden) {
    swal.fire('Error', 'Orden no válida', 'error');
    return;
  }

  if (orden.estado?.codigo === 'PENDIENTE') {
      //preguntas si desea enviar la orden
      swal.fire({
        title: 'Pendiente de envío',
        text: 'La orden está pendiente de envío. ¿Desea enviarla?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, enviar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // Aquí puedes conectar con el endpoint para enviar la orden.
        //  console.log('Orden enviada:', orden);
          this.entregarOrden(orden);
          //servicio para enviar la orden

        }
      });

    
  }
}

entregarOrden(ordenes: any[]): void {
  console.log('Entregar orden:', ordenes);
    // Aquí puedes conectar con el endpoint para marcar la orden como entregada.


  this.OrdenMantenimientoService.gestionarOrden(ordenes,2)
  .subscribe({
    next: (response) => {
      console.log('Respuesta:', response);
      if (response && response.codigo === 0) {
        swal.fire('Éxito', 'Orden gestionada correctamente', 'success');
        this.cargarOrdenes();
        this.cerrarDetalleOrden();
      } else {
        swal.fire('Error', 'No se pudo gestionar la orden', 'error');
      }
    },
    error: (error) => {
      console.error('Error al gestionar orden:', error);
    }
  });
}

cancelarOrden(orden: any): void {
  console.log('Cancelar orden:', orden);
    // Aquí puedes conectar con el endpoint para marcar la orden como cancelada.


  this.OrdenMantenimientoService.gestionarOrden(orden,7)
  .subscribe({
    next: (response) => {
      console.log('Respuesta:', response);
      if (response && response.codigo === 0) {
        swal.fire('Éxito', 'Orden gestionada correctamente', 'success');
        this.cargarOrdenes();
        this.cerrarDetalleOrden();
      } else {
        swal.fire('Error', 'No se pudo gestionar la orden', 'error');
      }
    },
    error: (error) => {
      console.error('Error al gestionar orden:', error);
    }
  });
}

pausarOrden(orden: any): void {
  console.log('Pausar orden:', orden);
    // Aquí puedes conectar con el endpoint para marcar la orden como pausada.


  this.OrdenMantenimientoService.gestionarOrden(orden,5)
  .subscribe({
    next: (response) => {
      console.log('Respuesta:', response);
      if (response && response.codigo === 0) {
        swal.fire('Éxito', 'Orden gestionada correctamente', 'success');
        this.cargarOrdenes();
        this.cerrarDetalleOrden();
      } else {
        swal.fire('Error', 'No se pudo gestionar la orden', 'error');
      }
    },
    error: (error) => {
      console.error('Error al gestionar orden:', error);
    }
  });
}

reanudarOrden(orden: any): void {
  console.log('Reanudar orden:', orden);
    // Aquí puedes conectar con el endpoint para marcar la orden como reanudada.


  this.OrdenMantenimientoService.gestionarOrden(orden,1)
  .subscribe({
    next: (response) => {
      console.log('Respuesta:', response);
      if (response && response.codigo === 0) {
        swal.fire('Éxito', 'Orden gestionada correctamente', 'success');
        this.cargarOrdenes();
        this.cerrarDetalleOrden();
      } else {
        swal.fire('Error', 'No se pudo gestionar la orden', 'error');
      }
    },
    error: (error) => {
      console.error('Error al gestionar orden:', error);
    }
  });
}

getEstadoOrden(orden: any): string {
  return orden?.estado?.codigo || 'DESCONOCIDO';
}
/**
 * Abre el modal desde el botón Gestionar.
 * La actividad finalizada solo se puede consultar.
 */
gestionarActividad(actividad: any): void {
  this.actividadSeleccionada = actividad;

  const estado = this.estadoCodigo(actividad);
  this.modoConsulta = estado === 'REALIZADA';

  this.evidenciasSeleccionadas = [];

  this.formResultadoActividad.reset({
    resultado: 'REALIZADA',
    kilometraje_ejecucion:
      actividad.kilometraje_ejecucion ?? null,
    fecha_ejecucion:
      actividad.fecha_finalizacion?.substring(0, 10)
      ?? this.fechaLocalActual(),
    diagnostico: actividad.diagnostico ?? '',
    trabajo_realizado: actividad.trabajo_realizado ?? '',
    trabajo_pendiente: actividad.trabajo_pendiente ?? '',
    motivo_no_realizacion: actividad.motivo_no_realizacion ?? '',
    observaciones: actividad.observaciones ?? '',
    requiere_seguimiento: actividad.requiere_seguimiento ?? false,
    descripcion_seguimiento: actividad.descripcion_seguimiento ?? ''
  });


  
  this.actualizarValidacionesResultado(
    this.formResultadoActividad.get('resultado')!.value
  );

  if (this.modoConsulta) {
    this.formResultadoActividad.disable();
  } else {
    this.formResultadoActividad.enable();
  }

  this.mostrarModalActividad = true;
}

/**
 * Validación visual del estado.
 * Adapta los códigos a los de tu catálogo real.
 */
estadoCodigo(actividad: any): string {
  return (
    actividad?.estadoActividadMantenimiento?.codigo
    ?? actividad?.estado_codigo
    ?? ''
  ).toUpperCase();
}

private fechaLocalActual(): string {
  const fecha = new Date();
  const anio = fecha.getFullYear();
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const dia = String(fecha.getDate()).padStart(2, '0');

  return `${anio}-${mes}-${dia}`;
}


 cargarActividadesOrden(idOrden:number): void {
  
  this.OrdenMantenimientoService
  .getActividades(idOrden)
  .subscribe({
    next: (response: any) => {

      // El servicio devuelve directamente un arreglo
      const actividades: ActividadOrden[] =
        Array.isArray(response) ? response : [];

      this.actividadesOrden = actividades;
      this.actualizarProgresoActividades();

      this.ordenSeleccionada = {
        ...this.ordenSeleccionada,
        actividadesOrden: actividades
      };

   
    },
    error: (error: any) => {
      console.error(
        'Error al obtener las actividades de la orden:',
        error
      );

      this.actividadesOrden = [];

      this.ordenSeleccionada = {
        ...this.ordenSeleccionada,
        actividadesOrden: []
      };
    }
  });
}

actualizarProgresoActividades(): void {
  const total = this.actividadesOrden?.length || 0;
  const realizadas = this.contarActividades('REALIZADA');

  this.progresoActividades = total === 0
    ? 0
    : Math.round((realizadas / total) * 100);

  // Solo finalizar cuando todas las actividades estén realizadas
  if (
    this.progresoActividades !== 100 ||
    !this.ordenSeleccionada ||
    this.finalizandoOrden
  ) {
    return;
  }

  // Evitar finalizar nuevamente una orden ya finalizada
  if (
    this.ordenSeleccionada.estado?.codigo === 'FINALIZADA' ||
    this.ordenSeleccionada.estado_id === 6
  ) {
    return;
  }

  this.finalizandoOrden = true;

  this.OrdenMantenimientoService
    .finalizarOrdenYProgramaciones(this.ordenSeleccionada.id)
    .subscribe({
      next: (response) => {
        if (response?.codigo === 0) {
          swal.fire(
            'Éxito',
            'Orden finalizada y programaciones ejecutadas correctamente.',
            'success'
          );

          this.cargarOrdenes();
        } else {
          swal.fire(
            'Error',
            response?.mensaje || 'No se pudo finalizar la orden.',
            'error'
          );
        }
      },
      error: (error) => {
        console.error('Error al finalizar orden:', error);

        swal.fire(
          'Error',
          error?.error?.mensaje ||
            'No se pudo finalizar la orden y sus programaciones.',
          'error'
        );
      },
      complete: () => {
        this.finalizandoOrden = false;
      }
    });
}



generarPdfOrden(): void {
  console.log('Generando PDF para la orden:', this.ordenSeleccionada);
  const orden = this.ordenSeleccionada;
  const actividades = this.actividadesOrden || [];

  if (!orden) {
    Swal.fire({
      icon: 'warning',
      title: 'Orden no seleccionada',
      text: 'Selecciona una orden de mantenimiento para generar el PDF.'
    });
    return;
  }

  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4'
  });

  const anchoPagina = doc.internal.pageSize.getWidth();
  const margen = 10;

  // Empresa
  const nombreEmpresa =this.administraciones[0].empresa 

  const nit = this.administraciones[0].nit;

  // Datos de la orden
  const numeroOrden = orden.numero_orden || `OM-${orden.id}`;
  const placa = orden.placa || 'No registrada';

  const fecha = orden.fecha_generacion ||
    orden.fecha_creacion ||
    orden.created_at;

  const fechaTexto = fecha
    ? new Date(fecha).toLocaleDateString('es-CO', {
        timeZone: 'America/Bogota',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    : new Date().toLocaleDateString('es-CO', {
        timeZone: 'America/Bogota'
      });

  const tipoMantenimiento =
    orden.tipoMantenimiento?.nombre ||
    orden.tipo_mantenimiento ||
    orden.tipo_mantenimiento_id ||
    'No especificado';

  const prioridad =
    orden.prioridadMantenimiento?.nombre ||
    orden.prioridad?.nombre ||
    orden.prioridad_id ||
    'Normal';

  const estado =
    orden.estado?.descripcion ||
    orden.estado?.codigo ||
    orden.estado_id ||
    'Pendiente';

  const kilometraje = Number(
    orden.kilometraje_generacion ?? orden.km ?? 0
  );

  const formatoKm = (valor: number): string =>
    valor.toLocaleString('es-CO', {
      maximumFractionDigits: 0
    });

  // Encabezado
  doc.setFillColor(68,68,68);
  doc.rect(0, 0, anchoPagina, 26, 'F');

  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(17);
  doc.text(String(nombreEmpresa), margen, 13);

  doc.setFontSize(11);
  doc.text(String(nit), margen, 20);

  doc.setFontSize(14);
  doc.text(
    'ORDEN DE MANTENIMIENTO',
    anchoPagina - margen,
    14,
    { align: 'right' }
  );

  doc.setFontSize(10);
  doc.text(
    numeroOrden,
    anchoPagina - margen,
    22,
    { align: 'right' }
  );

  // Información de empresa
  let y = 35;

  doc.setTextColor(40, 40, 40);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  //doc.text(nombreEmpresa, margen, y);

  if (nit) {
   // doc.setFont('helvetica', 'normal');
   // doc.text(`NIT: ${nit}`, margen, y + 6);
    //y += 6;
  }

  // Información general
  y += 9;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('1. INFORMACIÓN GENERAL', margen, y);

  autoTable(doc, {
    startY: y + 3,
    margin: { left: margen, right: margen },
    theme: 'grid',
    styles: {
      fontSize: 9,
      cellPadding: 3,
      textColor: [50, 50, 50]
    },
    headStyles: {
      fillColor: [245, 245, 245],
      textColor: [40, 40, 40],
      fontStyle: 'bold'
    },
    body: [
      [
        'Fecha de emisión',
        fechaTexto,
        'Estado',
        String(estado)
      ],
      [
        'Tipo de mantenimiento',
        String(tipoMantenimiento),
        'Prioridad',
        String(prioridad)
      ]
    ],
    columnStyles: {
      0: { cellWidth: 34, fontStyle: 'bold' },
      1: { cellWidth: 52 },
      2: { cellWidth: 25, fontStyle: 'bold' },
      3: { cellWidth: 'auto' }
    }
  });

  y = (doc as any).lastAutoTable.finalY + 9;

  // Información del vehículo
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('2. INFORMACIÓN DEL VEHÍCULO', margen, y);

  autoTable(doc, {
    startY: y + 3,
    margin: { left: margen, right: margen },
    theme: 'grid',
    styles: {
      fontSize: 9,
      cellPadding: 3
    },
    body: [
      [
        'Placa',
        placa,
        'Kilometraje',
        `${formatoKm(kilometraje)} km`
      ],
      /* [
        'Marca',
        String(orden.marca || orden.VehicleModel?.marca || '—'),
        'Modelo',
        String(orden.modelo || orden.VehicleModel?.modelo || '—')
      ], */
      [
        'Conductor',
        String(
          orden.conductor?.nombre ||
          orden.conductor_nombre ||
          orden.conductor ||
          '—'
        ),
        'Fecha programada',
        String(orden.fecha_programada || '—')
      ]
    ],
    columnStyles: {
      0: { cellWidth: 25, fontStyle: 'bold' },
      1: { cellWidth: 55 },
      2: { cellWidth: 28, fontStyle: 'bold' },
      3: { cellWidth: 'auto' }
    }
  });

  y = (doc as any).lastAutoTable.finalY + 9;

  // Actividades
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('3. ACTIVIDADES DE MANTENIMIENTO', margen, y);

  console.log('Actividades:', actividades);
  
const filasActividades = actividades.length
  ? actividades.map((item: any, index: number) => [
      String(index + 1),
      String(
        item.servicioRealizado?.tipo_de_mantenimiento ||
        `Actividad ${index + 1}`
      ),
      String(
        item.trabajo_realizado ||
        item.observaciones ||
        item.diagnostico ||
        'Pendiente de ejecución'
      ),
      String(
        item.estadoActividadMantenimiento?.nombre ||
        item.estadoActividadMantenimiento?.codigo ||
        'Pendiente'
      )
    ])
  : [['1', 'Sin actividades registradas', '—', '—']];

autoTable(doc, {
  startY: y + 3,
  margin: { left: margen, right: margen },
  theme: 'grid',
  head: [[
    'N.º',
    'Actividad',
    'Descripción / instrucciones',
    'Estado'
  ]],
  body: filasActividades,
  headStyles: {
    fillColor: [91,91, 91],
    textColor: [255, 255, 255],
    fontSize: 8
  },
  styles: {
    fontSize: 8,
    cellPadding: 3,
    overflow: 'linebreak',
    valign: 'middle'
  },
  columnStyles: {
    0: { cellWidth: 10, halign: 'center' },
    1: { cellWidth: 58 },
    2: { cellWidth: 75 },
    3: { cellWidth: 'auto' }
  }
});

y = (doc as any).lastAutoTable.finalY + 9;


  /* autoTable(doc, {
    startY: y + 3,
    margin: { left: margen, right: margen },
    theme: 'grid',
    head: [['N.º', 'Actividad', 'Descripción / instrucciones']],
    body: filasActividades,
    headStyles: {
      fillColor: [185, 28, 28],
      textColor: [255, 255, 255],
      fontSize: 9
    },
    styles: {
      fontSize: 8,
      cellPadding: 3,
      overflow: 'linebreak'
    },
    columnStyles: {
      0: { cellWidth: 12, halign: 'center' },
      1: { cellWidth: 65 },
      2: { cellWidth: 'auto' }
    }
  }); */

  y = (doc as any).lastAutoTable.finalY + 9;

  // Observaciones
  if (y > 225) {
    doc.addPage();
    y = 20;
  }

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('4. OBSERVACIONES', margen, y);

  y += 4;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);

  const observaciones = String(
    orden.observaciones || orden.motivo || 'Sin observaciones.'
  );

  const lineas = doc.splitTextToSize(
    observaciones,
    anchoPagina - margen * 2
  );

  doc.text(lineas, margen, y);

  y += lineas.length * 5 + 12;

  // Firmas
  if (y > 250) {
    doc.addPage();
    y = 30;
  }

  const anchoFirma = 75;
  const espacioEntreFirmas = anchoPagina - margen * 2 - anchoFirma * 2;
  const xFirmaDerecha = margen + anchoFirma + espacioEntreFirmas;

  doc.setDrawColor(120, 120, 120);

  doc.line(margen, y + 14, margen + anchoFirma, y + 14);
  doc.line(
    xFirmaDerecha,
    y + 14,
    xFirmaDerecha + anchoFirma,
    y + 14
  );

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);

  doc.text('Entrega el vehículo', margen, y + 20);
  doc.text('Recibe el vehículo', xFirmaDerecha, y + 20);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);

  doc.text('Nombre y firma', margen, y + 25);
  doc.text('Nombre y firma', xFirmaDerecha, y + 25);

  // Pie de página en todas las páginas
  const totalPaginas = doc.getNumberOfPages();

  for (let pagina = 1; pagina <= totalPaginas; pagina++) {
    doc.setPage(pagina);

    const altoPagina = doc.internal.pageSize.getHeight();

    doc.setFontSize(8);
    doc.setTextColor(120, 120, 120);

    doc.text(
      'Documento generado por Admin SEAF',
      margen,
      altoPagina - 8
    );

    doc.text(
      `Página ${pagina} de ${totalPaginas}`,
      anchoPagina - margen,
      altoPagina - 8,
      { align: 'right' }
    );
  }

  // Abrir PDF en el navegador
  const blob = doc.output('blob');
  const url = URL.createObjectURL(blob);

  window.open(url, '_blank');

  // Alternativa para descargar directamente:
  // doc.save(`Orden_${numeroOrden}.pdf`);
}


  cargarAdministracion(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
        this.administraciones = data;
        if (data?.length > 0) {
         // console.log('Administraciones obtenidas:', data);
          //console.log('Empresa de la primera administración:', this.administraciones[0].empresa);
         // console.log('Tenant ID de la primera administración:', this.administraciones[0].nit);
          // Regenerar QR con el tenantId correcto
        
        }
      },
      error: () => {}
    });
  }


}

